import React from 'react';
import { getConfiguration } from '../../utils/configuration';
import { getFormattedTimestamp } from '../../utils/getFormattedTimestamp';
import { getCurrencyValue } from '../../utils/getCurrencyValue';
import ShopReceiptHeader from './common-includes/ShopReceiptHeader';
import ShopReceiptFooter from './common-includes/ShopReceiptFooter';
import { getLabel } from '../../../data/labels';


function PhysicalRestVoucherPayment(props) {
	const conf = getConfiguration();
	
	const additionalStyle = {
			"fontFamily" : "sans-serif",
			"fontSize" : "19px"
	};


	const opData = props.data;
	const operationTitle = getLabel('retail.operator_menu.pay_physical_voucher.receipt_title');
	const amount = getCurrencyValue(opData.amount, conf.cs.m, conf.cs.nd, conf.cs.ct);
	const terminalBalance = getCurrencyValue(opData.terminalBalance, conf.cs.m, conf.cs.nd, conf.cs.ct);
	return (
		<body style={additionalStyle}>

			<ShopReceiptHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} operationTitle={operationTitle}></ShopReceiptHeader>
			
			<div>{getLabel('retail.date_time') + ": " + getFormattedTimestamp()}</div>
			<div>{getLabel('retail.amount') + ": " + amount}</div>
			{
				opData.showTerminalBalance && <div>{getLabel('retail.terminal_balance') + ": " + terminalBalance}</div>
			}
			<div>{getLabel('retail.terminal_number') + ": " + opData.idTag}</div>
			{ 
				opData.showOperatorName && <div>{getLabel('retail.operator') + ": " + opData.operator}</div>
			}
			<hr className="hr-line" />
				
			<div className="centerText">{opData.idt}</div>
			
			<ShopReceiptFooter></ShopReceiptFooter>
		</body>
    );
}

export default PhysicalRestVoucherPayment;